/**
 * Global Error Handler
 * Captures unhandled errors and displays them to users
 */

let toastHandler = null;

export const setGlobalErrorHandler = (showError) => {
  toastHandler = showError;
};

/**
 * Handle unhandled promise rejections
 */
export const setupGlobalErrorHandlers = () => {
  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled promise rejection:', event.reason);
    
    if (toastHandler) {
      const message = event.reason?.message || 'An unexpected error occurred';
      toastHandler(message);
    }
    
    // Prevent default browser error handling
    event.preventDefault();
  });

  // Handle global errors
  window.addEventListener('error', (event) => {
    console.error('Global error:', event.error);
    
    if (toastHandler && event.error) {
      const message = event.error.message || 'An unexpected error occurred';
      toastHandler(message);
    }
  });

  // Handle React errors (will be caught by Error Boundary)
  console.log('Global error handlers initialized');
};

/**
 * Manually report an error to the user
 */
export const reportError = (error, context = '') => {
  console.error(`Error ${context}:`, error);
  
  if (toastHandler) {
    const message = error?.message || error || 'An error occurred';
    toastHandler(message);
  }
};
